import { useState, useEffect, useContext } from "react";
import {
  Avatar,
  Button,
  Card,
  Col,
  Dropdown,
  Form,
  Image,
  Input,
  Modal,
  Row,
  Select,
  Upload as UploadAntd,
  message,
} from "antd";
import {
  DownOutlined,
  KeyOutlined,
  LogoutOutlined,
  UploadOutlined,
  UserOutlined,
  BellOutlined,
} from "@ant-design/icons";

import notfound from "../../assets/images/not_found.png";
import { NavLink, useNavigate } from "react-router-dom";
import DeleteModal from "../../components/DeleteModal";
import { Severty, ShowToast } from "../../helper/toast";
import { AuthContext } from "../../context/AuthContext";
import Notification from "../../assets/images/notification.svg";
import { useAppContext } from "../../context/AppContext";
import lang from "../../helper/lang";
import Prouser from "../../assets/images/user.png";
import NotificationImage from "../../assets/images/bell_iconnn.png";

const Search = Input.Search;
const { Option } = Select;
const toggler = [
  <svg
    width="20"
    height="20"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    key={0}
  >
    <path d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"></path>
  </svg>,
];

function Header({ onPress, setToggle }) {
  const [visible, setVisible] = useState(false);
  const [profileVisible, setProfileVisible] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [appSettingVisible, setAppSettingVisible] = useState(false);
  const [notificationVisible, setNotificationVisible] = useState(false);
  const { logout } = useContext(AuthContext);

  const navigate = useNavigate();
  const { notification, notificationCount, setRefreshNotification, language } =
    useAppContext();
  const [isLogoutModalVisible, setIsLogoutModalVisible] = useState(false);

  // Dummy notifications for demonstration
  const dummyNotifications = [
    {
      id: 1,
      title: "New User Registration",
      description: "A new user has registered in the system",
      time: "2 minutes ago",
      type: "user",
    },
    {
      id: 2,
      title: "Payment Received",
      description: "Payment of $50 has been received from vendor",
      time: "15 minutes ago",
      type: "payment",
    },
    {
      id: 3,
      title: "System Update",
      description: "System maintenance scheduled for tonight at 2 AM",
      time: "1 hour ago",
      type: "system",
    },
    {
      id: 4,
      title: "New Tournament Created",
      description: "A new tournament 'Summer Championship' has been created",
      time: "2 hours ago",
      type: "tournament",
    },
    {
      id: 5,
      title: "Low Storage Warning",
      description: "Server storage is running low. Please clean up old files",
      time: "3 hours ago",
      type: "warning",
    },
  ];

  useEffect(() => {
    if (!isOpen) return document.body.classList.remove("edit-dropdown");
    document.body.classList.add("edit-dropdown");

    return () => {
      document.body.classList.remove("edit-dropdown");
    };
  }, [isOpen]);

  const showDeleteConfirm = (record) => {
    setIsLogoutModalVisible(true);
  };

  // const notificationitems = [
  //   {
  //     label: (
  //       <div className="notification_top">
  //         <div className="notification-head">
  //           <h5>{lang("Notifications")}</h5>
  //         </div>
  //         <div className="notification-inner">
  //           {dummyNotifications?.length ? (
  //             dummyNotifications?.map((item) => (
  //               <div
  //                 key={item.id}
  //                 className="single-notification"
  //                 onClick={() => {
  //                   // Handle notification click
  //                   console.log("Notification clicked:", item);
  //                 }}
  //               >
  //                 <div className="notification-img">
  //                   <img src={Prouser} alt="notification" />
  //                 </div>
  //                 <div className="notification-cont">
  //                   <p>
  //                     <span className="notification-title">{item.title}</span>
  //                     <p className="notification-desc">{item.description}</p>
  //                     <small className="notification-time">{item.time}</small>
  //                   </p>
  //                 </div>
  //               </div>
  //             ))
  //           ) : (
  //             <span>{lang("No Notification")}</span>
  //           )}
  //         </div>
  //         {dummyNotifications?.length ? (
  //           <div className="viewAll_notification">
  //             <Button
  //               onClick={() => navigate("/notifications-manager")}
  //               className="btnStyle btn_primary"
  //             >
  //               {lang("View All")}
  //             </Button>
  //           </div>
  //         ) : (
  //           ""
  //         )}
  //       </div>
  //     ),
  //   },
  // ];
  const getFromStorage = (key) => {
    try {
      return JSON.parse(localStorage.getItem(key));
    } catch {
      return null;
    }
  };
  const userProfile = getFromStorage("userProfile") || getFromStorage("user");
  const profilePic = userProfile?.profile_img || userProfile?.profilePic || notfound;
  const userName = userProfile?.full_name || userProfile?.name || "User";

  return (
    <>
      <Row className="align-items-center">
        <Col span={24} xs={18} md={18}>
          <div className="toggale-headr">
            <div className="moblile-toggle d-lg-none">
              <Button
                type="link"
                className="sidebar-toggler"
                onClick={() => onPress()}
              >
                {toggler}
              </Button>
            </div>
            <div className="">
              <Button
                type="link"
                className="sidebar-toggler ps-0 d-none d-lg-block"
                onClick={() => setToggle()}
              >
                {toggler}
              </Button>
            </div>
            <div className="tabLogo ">
              <h4>{lang("My Health My Ways")}</h4>
            </div>
          </div>
        </Col>
        <Col span={24} xs={6} md={6} className="header-control">
          <div className="d-flex align-items-center justify-content-end gap-3">
            {/* Notification Dropdown */}
            {/* <div className="notificationDropdownMain">
              <Dropdown
                menu={{ items: notificationitems }}
                placement="bottomRight"
                trigger={["click"]}
                open={notificationVisible}
                onOpenChange={setNotificationVisible}
              >
                <span className="notification-btn">
                  <div className="notification-icon-wrapper">
                    <img
                      src={NotificationImage}
                      alt="notification"
                      className="notification-icon"
                    />
                    {dummyNotifications.length > 0 && (
                      <span className="notification-badge">
                        {dummyNotifications.length}
                      </span>
                    )}
                  </div>
                </span>
              </Dropdown>
            </div> */}

            {/* Profile Dropdown */}
            <div className="profileDropdownMain">
              <Button
                className="ant-btn ant-btn-default ant-dropdown-trigger ant-dropdown-open"
                onClick={() => navigate("/profile")}
              >
                <div className=" d-flex align-items-center gap-2">
                  <div className="userImg" style={{ cursor: "pointer" }}>
                    <Image src={profilePic} preview={false} />
                  </div>
                  <div className="d-none d-xl-block">
                    <div className="userName">Welcome {userName}</div>
                  </div>
                </div>
              </Button>
            </div>
          </div>
        </Col>
      </Row>
      {isLogoutModalVisible && (
        <DeleteModal
          title={"Logout"}
          subtitle={`Are you sure you want to logout?`}
          show={isLogoutModalVisible}
          hide={() => {
            setIsLogoutModalVisible(false);
          }}
          onOk={() => {
            ShowToast("Logout Successfully!", Severty.SUCCESS);
            logout();
          }}
        />
      )}
    </>
  );
}

export default Header;
